export default {
    namespaced: true,
    state: {
        value: null,
    },
    mutations: {
        update(state, newDate) {
            state.value = newDate;
        },
    },
};